import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DownOutlined } from '@ant-design/icons';
import Quill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { Divider, Popover } from 'antd';
import styles from './MessageEditor.module.less';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
export const MessageEditor = (props)=>{
    var _editorQuillRef_current_getEditor, _editorQuillRef_current, _editorQuillRef_current_getEditor1, _editorQuillRef_current1;
    const { value, onChange, disabled } = props;
    const { t } = useTranslation();
    const editorQuillRef = useRef(null);
    const [toolbarClass] = useState(()=>{
        return `toolbar-${new Date().getTime().toString(36)}`;
    });
    useEffect(()=>{
        triggerChange(value);
    }, []);
    const triggerChange = (changedValue)=>{
        onChange === null || onChange === void 0 ? void 0 : onChange(changedValue);
    };
    const foucusRichText = ()=>{
        var _editorQuillRef_current;
        // TODO quill hasFocus api 有问题 如果没有聚焦, 则聚焦一下文本框, 防止在已有内容前面插入
        const hasFocus = (_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : _editorQuillRef_current.getEditor().hasFocus();
        if (!hasFocus) {
        // const contents = editorQuillRef.current?.getEditor().getText?.()
        // editorQuillRef.current?.getEditor().setSelection?.(value.msg_body?.length || contents?.length)
        }
    };
    const getCurrentCursor = ()=>{
        var _editorQuillRef_current;
        return ((_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : _editorQuillRef_current.getEditor().getSelection(true).index) || 0;
    };
    const insertStoreName = async ()=>{
        var _editorQuillRef_current;
        foucusRichText();
        // const contents = editorQuillRef.current?.getEditorContents?.()
        // const selection = editorQuillRef.current?.getEditor().getSelection(true).index
        let cursorPointer = getCurrentCursor();
        const newVal = ` {Store Name} `;
        (_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : _editorQuillRef_current.getEditor().insertText(cursorPointer, newVal);
    };
    const insertBuyerName = async ()=>{
        var _editorQuillRef_current;
        await foucusRichText();
        let cursorPointer = getCurrentCursor();
        const newVal = ` {Buyer Nickname} `;
        (_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : _editorQuillRef_current.getEditor().insertText(cursorPointer, newVal);
    };
    const content = /*#__PURE__*/ _jsxs("div", {
        className: styles.popover_container_wrap,
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: styles.popover_btn_span,
                onClick: insertBuyerName,
                children: t('au_a_buyer_nickname')
            }),
            /*#__PURE__*/ _jsx(Divider, {
                style: {
                    margin: 0
                }
            }),
            /*#__PURE__*/ _jsx("span", {
                className: styles.popover_btn_span,
                onClick: insertStoreName,
                children: t('au_a_store_name')
            })
        ]
    });
    const onEditorChange = ()=>{
        var _editorQuillRef_current_getEditor_getText, _editorQuillRef_current, _editorQuillRef_current_getEditor;
        const contents = (_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : (_editorQuillRef_current_getEditor_getText = (_editorQuillRef_current_getEditor = _editorQuillRef_current.getEditor()).getText) === null || _editorQuillRef_current_getEditor_getText === void 0 ? void 0 : _editorQuillRef_current_getEditor_getText.call(_editorQuillRef_current_getEditor);
        triggerChange(contents);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: classNames(styles.cst_toolbar_btn_wrap, props['aria-invalid'] ? styles.cst_toolbar_btn_wrap_has_error : ''),
                children: /*#__PURE__*/ _jsxs(Popover, {
                    content: content,
                    overlayClassName: classNames(styles.cst_popover_wrap),
                    overlayInnerStyle: {
                        padding: 0
                    },
                    arrow: false,
                    placement: "topRight",
                    children: [
                        /*#__PURE__*/ _jsx("span", {
                            className: "mr-2",
                            children: t('au_a_variable_parameter')
                        }),
                        /*#__PURE__*/ _jsx(DownOutlined, {})
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Quill, {
                ref: editorQuillRef,
                readOnly: disabled,
                style: {
                    height: `200px`,
                    transition: 'height .3s ease-out'
                },
                className: classNames(styles.ql, props['aria-invalid'] ? styles.ql_has_error : ''),
                modules: {
                    toolbar: {
                        container: `.${toolbarClass}`
                    }
                },
                defaultValue: value,
                onChange: onEditorChange,
                placeholder: t('au_a_message_content_plc')
            }),
            /*#__PURE__*/ _jsx("div", {
                className: classNames(styles.toolbar, toolbarClass, props['aria-invalid'] ? styles.toolbar_has_error : ''),
                children: /*#__PURE__*/ _jsx("div", {
                    className: styles.limit_length,
                    children: `${((_editorQuillRef_current = editorQuillRef.current) === null || _editorQuillRef_current === void 0 ? void 0 : (_editorQuillRef_current_getEditor = _editorQuillRef_current.getEditor()) === null || _editorQuillRef_current_getEditor === void 0 ? void 0 : _editorQuillRef_current_getEditor.getLength()) ? ((_editorQuillRef_current1 = editorQuillRef.current) === null || _editorQuillRef_current1 === void 0 ? void 0 : (_editorQuillRef_current_getEditor1 = _editorQuillRef_current1.getEditor()) === null || _editorQuillRef_current_getEditor1 === void 0 ? void 0 : _editorQuillRef_current_getEditor1.getLength()) - 1 : 0}
					/ 4000`
                })
            })
        ]
    });
};
